/* ============================================================
   KLAVO — client script.
   The only client-side behavior on the site: a countdown to the
   contest open datetime, rendered in monospace, to the second.
   "Precision as a trust signal." See rationale.md §1.

   Auto-attaches to any element with [data-klavo-countdown="<ISO>"]
   so the same script drives homepage hero + current-contest
   sealed state without either page having to inline JS.

   prefers-reduced-motion: the countdown is content change, not
   animation — the reduced-motion CSS above already kills the
   button transform. This script always ticks (users who set
   reduced-motion still want to know when the contest opens).
   ============================================================ */
(function () {
  'use strict';

  function pad(n) { return String(n).padStart(2, '0'); }

  function render(el, deltaMs) {
    var openedTemplate = el.getAttribute('data-open-text') || 'open now';
    var closedTemplate = el.getAttribute('data-closed-text') || 'contest closed';
    var mode = el.getAttribute('data-mode') || 'open'; // 'open' | 'close'

    if (deltaMs <= 0) {
      el.textContent = (mode === 'close') ? ' — ' + closedTemplate : ' — ' + openedTemplate;
      el.setAttribute('data-state', 'reached');
      return true; // stop ticking
    }
    var days = Math.floor(deltaMs / 864e5);
    var hrs  = Math.floor(deltaMs % 864e5 / 36e5);
    var min  = Math.floor(deltaMs % 36e5 / 6e4);
    var sec  = Math.floor(deltaMs % 6e4 / 1e3);
    var verb = (mode === 'close') ? 'closes in ' : 'opens in ';
    var prefix = el.getAttribute('data-prefix') || ' — ';
    el.textContent = prefix + verb + days + 'd ' +
      pad(hrs) + 'h ' + pad(min) + 'm ' + pad(sec) + 's';
    el.setAttribute('data-state', 'ticking');
    return false;
  }

  function attach(el) {
    var iso = el.getAttribute('data-klavo-countdown');
    if (!iso) return;
    var target = new Date(iso).getTime();
    if (isNaN(target)) {
      el.textContent = '';
      return;
    }
    function tick() {
      var done = render(el, target - Date.now());
      if (!done) window.setTimeout(tick, 1000);
    }
    tick();
  }

  function init() {
    var nodes = document.querySelectorAll('[data-klavo-countdown]');
    for (var i = 0; i < nodes.length; i++) attach(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
